// extracted by mini-css-extract-plugin
module.exports = {"root":"PersonalEmailDomainsSettings_root__28t9y","addRow":"PersonalEmailDomainsSettings_addRow__3z3_I","loading":"PersonalEmailDomainsSettings_loading__3euIp"};